export default __webpack_public_path__ + "static/media/inactive-facility-legend-icon-new.9444a95c.svg";